import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { MaterialExposureSurvey } from './MaterialExposureSurvey';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialExposureSurveyIsomer extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   materialExposureSurveyIsomerId: number;
   materialId: number;
   materialExposureSurveyId: number;
   notes: string;
   originalSurveyId: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   material: Material;
   materialExposureSurvey: MaterialExposureSurvey;
}

